import { FC, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { z } from 'zod'

import Button from '@/components/Button'
import '@/components/Form/Atoms/ProductQuantityInput/ProductQuantityInput.scss'
import Text from '@/components/Text'
import FormResolverUtils from '@/utils/FormResolverUtils'
import { InputKey } from '@/utils/inputKey'

export const productQuantityDefaultValue = '1'

const formResolverUtils = FormResolverUtils({ schema: z.string(), i18nName: '個数' })

const productQuantities = new Array(3).fill(null).map((_, i) => i + 1)
const values = Object.fromEntries(
  productQuantities.map((productQuantity) => {
    return [productQuantity, productQuantity]
  })
)

export const productQuantityInputKey = InputKey('productQuantity', formResolverUtils.enum(values).schema)

type Props = {
  max?: number
  min?: number
  step?: number
}

const ProductQuantityInput: FC<Props> = ({ max = 100, min = 1, step = 1 }) => {
  const { setValue, watch } = useFormContext()
  const currentValue = watch(productQuantityInputKey.name)

  const handleButtonClick = useCallback(
    (n: number) => {
      const newValue = Math.max(min, Math.min(max, Number(currentValue) + Number(n)))
      setValue(productQuantityInputKey.name, newValue)
    },
    [currentValue]
  )

  return (
    <div className="c-productQuantityInput">
      <Button
        className="c-productQuantityInput__button c-button--skeleton"
        fontSize="1.4rem"
        padding="unset"
        lineHeight={'unset'}
        onClick={() => handleButtonClick(-step)}
      >
        <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="6.5" y1="3.5" x2="0.5" y2="3.5" stroke="#060725" />
        </svg>
      </Button>
      <Text>{currentValue.toString().padStart(2, '0')}</Text>
      <Button
        className="c-productQuantityInput__button c-button--skeleton"
        fontSize="1.4rem"
        padding="unset"
        lineHeight={'unset'}
        onClick={() => handleButtonClick(step)}
      >
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="6.5" y1="9.5" x2="6.5" y2="3.5" stroke="#060725" />
          <line x1="9.5" y1="6.5" x2="3.5" y2="6.5" stroke="#060725" />
        </svg>
      </Button>
    </div>
  )
}

export default ProductQuantityInput
